import { combineReducers } from "redux";

import Country from "./Country";
import Province from "./Province";
import Language from "./Language";
import ReferencePlatform from "./ReferencePlatform";
import RequestType from "./RequestType";
import ReturnReason from "./ReturnReason";

export default combineReducers({
    Country,
    Province,
    Language,
    ReferencePlatform,
    RequestType,
    ReturnReason
});
